var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlayActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40mm",
    height: "40mm",
    viewBox: "0 0 40 40",
    id: "svg5",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnssvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3076",
    transform: "matrix(0.85887612,0,0,0.85887612,-76.733636,-86.213355)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3071"
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      fontVariationSettings: "normal",
      opacity: 0.9,
      vectorEffect: "none",
      fill: "#ff0000",
      fillOpacity: 1,
      strokeWidth: 0.457072,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      InkscapeStroke: "none",
      stopColor: "#000000",
      stopOpacity: 1
    },
    id: "circle2159",
    cx: 112.62816,
    cy: 123.66551,
    r: 23.286245
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      strokeWidth: 1.42728,
      InkscapeStroke: "none",
      stopColor: "#000000"
    },
    id: "path2161",
    d: "m 12.603947,756.48808 0,-54.77721 0,-54.7772 47.438451,27.38861 47.438452,27.3886 -47.438455,27.3886 z",
    transform: "matrix(0.17256282,0,0,0.18958943,104.73272,-9.1876661)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayActive);
export default __webpack_public_path__ + "static/media/playActive.251cf9c0253e3c443c527dd68fe76f2a.svg";
export { ForwardRef as ReactComponent };